{
  "app": {
    "title": "یار شخصی برنامه‌ریزی شما",
    "subtitle": "سازمان‌دهی • برنامه‌ریزی • موفقیت"
  },
  "header": {
    "brand": "اسطورهای زندگی خودت باش",
    "tagline": "برنامه‌ریزی ‌هوشمند • زندگی بهتر"
  },
  "common": {
    "loading": "بارگذاری...",
    "retry": "تلاش دوباره",
    "error": "خطا",
    "success": "موفقیت",
    "warning": "هشدار",
    "info": "اطلاعات",
    "add": "افزودن",
    "delete": "حذف",
    "edit": "ویرایش",
    "save": "ذخیره",
    "cancel": "لغو",
    "close": "بستن",
    "search": "جستجو",
    "filter": "فیلتر",
    "sort": "مرتب‌سازی",
    "empty": "خالی",
    "notFound": "یافت نشد"
  },
  "sidebar": {
    "dashboard": "داشبورد",
    "habit": "ردیاب عادت",
    "weekly": "برنامه‌ریزی هفتگی",
    "tasks": "برنامه ریزی درسی | کاری",
    "finance": "مدیریت مالی",
    "settings": "تنظیمات"
  },
  "dashboard": {
    "title": "داشبورد",
    "habitProgress": "پیشرفت عادت‌ها",
    "weeklyProgress": "پیشرفت هفتگی",
    "tasksProgress": "خلاصه وظایف",
    "financeBalance": "موجودی مالی",
    "bookmarks": "نشان‌گذاری‌ها",
    "tools": "ابزارها"
  },
  "habit": {
    "title": "ردیاب عادت",
    "addNew": "افزودن عادت جدید",
    "monthlyGoal": "هدف ماهانه",
    "days": "روز",
    "progress": "پیشرفت",
    "noHabits": "هیچ عادتی ثبت نشده",
    "deleteConfirm": "آیا مطمئن هستید؟",
    "day": "روز",
    "quickAdd": "افزودن سریع...",
    "total": "کل عادات",
    "today": "امروز",
    "longestStreak": "طولانی‌ترین رشته",
    "markDoneToday": "علامت‌گذاری برای امروز",
    "markUndone": "لغو علامت",
    "renamePrompt": "نام جدید عادت را وارد کنید",
    "hint": "هدف ماهانه را مشخص کنید",
    "clear": "پاک‌کردن",
    "streakInfo": "رشته‌ای از روزهای متوالی",
    "stats": "آمار",
    "completePercent": "درصد تکمیل",
    "completedDays": "روزهای تکمیل شده",
    "totalDays": "کل روزهای ماه",
    "best": "بهترین",
    "currentMonth": "این ماه",
    "allHabits": "تمام عادات",
    "active": "فعال",
    "completed": "تکمیل شده",
    "pending": "در انتظار",
    "frequency": "فرکانس",
    "daily": "روزانه",
    "weekly": "هفتگی",
    "monthly": "ماهانه",
    "reminder": "یادآور",
    "notifications": "اطلاع‌رسانی‌ها",
    "enableReminders": "فعال‌سازی یادآورها",
    "reminderTime": "زمان یادآور",
    "color": "رنگ",
    "icon": "نماد",
    "category": "دسته‌بندی",
    "description": "توضیح",
    "notes": "یادداشت‌ها",
    "history": "تاریخچه",
    "thisMonth": "این ماه",
    "lastMonth": "ماه قبل",
    "year": "سال",
    "export": "برون‌ریزی",
    "import": "وارد‌کردن",
    "achievements": "دستاوردها",
    "badges": "نشان‌ها",
    "milestone": "مرحله"
  },
  "weekly": {
    "title": "برنامه‌ریزی هفتگی",
    "viewMode": "نوع نمایش",
    "weekView": "نمایش هفتگی",
    "listView": "نمایش لیست‌ی",
    "addTask": "افزودن وظیفه",
    "newTask": "وظیفه جدید",
    "noTasks": "هیچ وظیفه‌ای برنامه‌ریزی نشده",
    "saturday": "شنبه",
    "sunday": "یکشنبه",
    "monday": "دوشنبه",
    "tuesday": "سه‌شنبه",
    "wednesday": "چهارشنبه",
    "thursday": "پنج‌شنبه",
    "friday": "جمعه",
    "today": "امروز",
    "totalTasks": "کل وظایف",
    "completed": "تکمیل‌شده",
    "pending": "درحال‌انجام",
    "progressPercentage": "درصد پیشرفت",
    "filterAll": "همه",
    "filterPending": "درحال‌انجام",
    "filterCompleted": "تکمیل‌شده"
  },
  "tasks": {
    "title": "برنامه ریزی درسی | کاری",
    "newTask": "وظیفه جدید",
    "addTask": "افزودن",
    "category": "دسته‌بندی",
    "priority": "اولویت",
    "general": "عمومی",
    "study": "درسی",
    "work": "کاری",
    "low": "کم",
    "medium": "متوسط",
    "high": "زیاد",
    "noTasks": "هیچ وظیفه‌ای موجود نیست",
    "allCategories": "همه دسته‌ها",
    "allPriorities": "همه اولویت‌ها"
  },
  "finance": {
    "title": "مدیریت مالی",
    "income": "درآمد",
    "expense": "هزینه",
    "balance": "موجودی",
    "addIncome": "ثبت درآمد",
    "addExpense": "ثبت هزینه",
    "amount": "مبلغ",
    "date": "تاریخ",
    "description": "توضیح",
    "noItems": "هیچ موردی ثبت نشده",
    "totalIncome": "کل درآمد",
    "totalExpense": "کل هزینه",
    "netBalance": "موجودی خالص"
  },
  "settings": {
    "title": "تنظیمات",
    "theme": "تم",
    "language": "زبان",
    "calendar": "تقویم",
    "light": "روز",
    "dark": "شب",
    "persian": "فارسی",
    "english": "انگلیسی",
    "jalali": "جلالی",
    "gregorian": "میلادی",
    "backup": "پشتیبان‌گیری",
    "export": "برون‌ریزی",
    "import": "وارد‌کردن",
    "clear": "پاک‌کردن",
    "clearConfirm": "این عملیات غیرقابل بازگشت است. آیا مطمئن هستید?",
    "clocks": "ساعت‌های جهانی",
    "weather": "آب‌وهوا",
    "addClock": "افزودن ساعت",
    "addWeather": "افزودن شهر",
    "clearHabits": "پاک‌کردن تمام عادات",
    "clearHabitsShort": "عادات",
    "clearHabitsDescription": "این عملیات تمام عادات و اطلاعات مربوط به آن‌ها را حذف می‌کند. این کار غیرقابل بازگشت است.",
    "clearHabitsWarning": "⚠️ هشدار: تمام عادات و تاریخچه‌ی آن‌ها حذف می‌شوند!\n\nاین عملیات غیرقابل بازگشت است و نمی‌توانید داده‌ها را برگردانید.\n\nآیا می‌خواهید ادامه دهید؟",
    "clearHabitsSuccess": "✅ تمام عادات با موفقیت حذف شدند\n\nداده‌های عادات شما پاک شده است.",
    "clearFinance": "مدیریت مالی",
    "clearFinanceWarning": "⚠️ هشدار: تمام درآمدها و هزینه‌ها حذف می‌شوند!\n\nاین عملیات غیرقابل بازگشت است و نمی‌توانید رکوردهای مالی را برگردانید.\n\nآیا می‌خواهید ادامه دهید؟",
    "clearFinanceSuccess": "✅ تمام رکوردهای مالی با موفقیت حذف شدند\n\nداده‌های مالی شما پاک شده است.",
    "clearTasks": "برنامه ریزی درسی | کاری",
    "clearTasksWarning": "⚠️ هشدار: تمام وظایف حذف می‌شوند!\n\nاین عملیات غیرقابل بازگشت است و نمی‌توانید وظایف حذف‌شده را برگردانید.\n\nآیا می‌خواهید ادامه دهید؟",
    "clearTasksSuccess": "✅ تمام وظایف با موفقیت حذف شدند\n\nداده‌های وظایف شما پاک شده است.",
    "clearWeekly": "برنامه ریزی هفتگی",
    "clearWeeklyWarning": "⚠️ هشدار: تمام برنامه‌های هفتگی حذف می‌شوند!\n\nاین عملیات غیرقابل بازگشت است و نمی‌توانید برنامه‌ها را برگردانید.\n\nآیا می‌خواهید ادامه دهید؟",
    "clearWeeklySuccess": "✅ تمام برنامه‌های هفتگی با موفقیت حذف شدند\n\nداده‌های برنامه‌ریزی هفتگی شما پاک شده است."
  },
  "error": {
    "title": "خطا رخ داد",
    "generic": "خطایی نامشخص رخ داد",
    "loadFailed": "بارگذاری ناموفق",
    "saveFailed": "ذخیره‌سازی ناموفق",
    "deleteFailed": "حذف ناموفق"
  },
  "success": {
    "saved": "ذخیره شد",
    "added": "اضافه شد",
    "deleted": "حذف شد",
    "updated": "به‌روزرسانی شد"
  },
  "jalaliDatePicker": {
    "year": "سال",
    "month": "ماه",
    "day": "روز",
    "confirm": "تایید",
    "cancel": "انصراف"
  }
}

